import { Injectable, inject } from '@angular/core';
import { NavOverflowGroup } from '@vg-constellation/angular-20/nav-overflow';

import { NavOverflowExtendedData } from '../../interfaces/nav-overflow-extended-data.interface';
import { ContentUtil } from '../../utils/content/content.util';
import { ZciOverflowMenuService } from '../zci-overflow-menu/zci-overflow-menu.service';

@Injectable({
    providedIn: 'root',
})
export class OtherAccountsService {
    private readonly navOverflowItemsService = inject(ZciOverflowMenuService);

    private readonly content = ContentUtil.content;

    private readonly zciOverflowItems = this.navOverflowItemsService.zciOverflowItems;

    private defaultMenuGroup: NavOverflowGroup[] = [
        {
            items: [this.zciOverflowItems.removeAccessFromAccount],
        },
    ];

    getNavOverflowMenu(): NavOverflowExtendedData {
        return {
            label: this.content.home.observableAccountTile.actionsMenuLabel,
            labelId: 'single_other_accounts_actions',
            data: {
                groups: this.defaultMenuGroup,
            },
        };
    }
}
